<template>
  <div>
    <h3 class="text-xl mb-6">Dietary Requirements</h3>
    <p class="text-xs mb-6">Please state any dietary requirements of allergies for your attendees:</p>
    <table v-if="! (order.additional_users.length === 0 && order.exclude_current_user)" class="w-full leading-normal mb-6">
      <tbody v-if="!order.exclude_current_user" class="border-b border-grey-light">
        <tr><td colspan="2" class="text-sm font-bold">{{ order.first_name + ' ' + order.last_name }} - {{ order.email }}</td></tr>
        <tr class="border-bottom">
          <td class="text-sm align-bottom pb-4" v-if="ticket.dietary_flag">
            <pl-select
              v-model="order.dietary_requirements"
              select-class="bg-white rounded h-10 py-0 shadow text-sm"
              class="lg:w-48 w-full"
            >
              <option :value="null">None</option>
              <option v-for="(dieatary, index) in dietaryOptions" :value="dieatary" :key="index">{{ dieatary }}</option>
            </pl-select>
          </td>
          <td class="text-sm pb-4" v-if="ticket.allergy_flag">
            <label class="block text-xs mb-1">Allergies:</label>
            <input type="text" placeholder="Type any allergies in here..." v-model="order.allergies" class="w-1/2 input bg-white text-grey-darkest">
          </td>
        </tr>
      </tbody>
      <tbody v-for="(registrant, i) in order.additional_users" :key="i" class="border-b border-grey-light">
        <tr><td colspan="2" class="pt-4 text-sm font-bold">{{ registrant.first_name + ' ' + registrant.last_name }} - {{ registrant.email }}</td></tr>
        <tr class="border-bottom">
          <td class="text-sm align-bottom pb-4" v-if="ticket.dietary_flag">
            <pl-select
              v-model="registrant.dietary_requirements"
              select-class="bg-white rounded h-10 py-0 shadow text-sm"
              class="lg:w-48 w-full"
            >
              <option :value="null">None</option>
              <option v-for="(dieatary, index) in dietaryOptions" :value="dieatary" :key="index">{{ dieatary }}</option>
            </pl-select>
          </td>
          <td class="text-sm pb-4" v-if="ticket.allergy_flag">
            <label class="block text-xs mb-1">Allergies:</label>
            <input type="text" placeholder="Type any allergies in here..." v-model="registrant.allergies" class="w-1/2 input bg-white text-grey-darkest">
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else>No attendee is added.</p>
  </div>
</template>
<script>
import { v2Api } from '@/http'

export default {
  props: ['event', 'ticket', 'order', 'errorBag'],
  data () {
    return {
      dietaryOptions: null
    }
  },
  created () {
    this.getDietaryOptions()
  },
  methods: {
    getDietaryOptions () {
      v2Api
        .get(`/event-tickets/dietary/enums`)
        .then(
          response => {
            this.dietaryOptions = response.data
          }
        )
    }
  }
}
</script>
